/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tl_Bar_RoleInputs */

const en_tl_bar_role = /** @type {(inputs: Tl_Bar_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`timeline bar`)
};

const de_tl_bar_role = /** @type {(inputs: Tl_Bar_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeitbalken`)
};

/**
* | output |
* | --- |
* | "timeline bar" |
*
* @param {Tl_Bar_RoleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tl_bar_role = /** @type {((inputs?: Tl_Bar_RoleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tl_Bar_RoleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_tl_bar_role(inputs)
	return en_tl_bar_role(inputs)
});